module.exports = __webpack_public_path__ + "static/media/Storybook-100.10e922e6.webp";